import React, { useContext } from 'react'
import { connect } from 'react-redux'

import GlobalContext from '../../../contexts/GlobalContext'
import { RootDispatch, RootState } from '../../../store'
import { bookingAddedSupplements } from '../../../store/supplement'

import BookingAccommodationList from '../BookingAccommodation/BookingAccommodationList'
import BookingDetailsAccordion, { AccordionType } from '../BookingAccordion/BookingDetailsAccordion'
import BookingAddedSupplementList from '../BookingsSupplements/BookingAddedSupplementList'

const mapProps = (state: RootState) => ({
  supplementAdded: state.supplement.added,
  bookingAddedSupplements: bookingAddedSupplements(state),
  bookingFolder: state.booking.bookingFolder,
})

const mapDispatch = (dispatch: RootDispatch) => ({
  loadSupplement: dispatch.supplement.load
})

type Props = {
  booking: any
  accommodationServiceName: string
} & ReturnType<typeof mapProps> & ReturnType<typeof mapDispatch>

const BookingAccordionDetails = ({
  booking,
  bookingAddedSupplements,
  supplementAdded,
  accommodationServiceName,
  bookingFolder,
  loadSupplement,
}: Props) => {
  const [globalContext] = useContext(GlobalContext) as any

  let totalAccommodation = booking.accommodationPriceTotal
  if ( bookingFolder.noteSecondaire ) {
    totalAccommodation = 0
    booking.bookingAccommodation.map((accommodation, index) => {
      if ( bookingFolder?.noteSecondaire && accommodation?.isNote ) {
        totalAccommodation += accommodation.totalAmount;
      }
    })

    if (totalAccommodation == 0) {
      totalAccommodation = ''
    }
  }

  return (
    <>
      <BookingDetailsAccordion
        title={`${globalContext.translations.accommodation}: ${accommodationServiceName}`}
        //amount={booking.accommodationPriceTotal}
        amount={totalAccommodation}
        currency={booking.currency}
        type={AccordionType.Hebergement}
      >
        <BookingAccommodationList bookingAccommodations={booking.bookingAccommodation} />
      </BookingDetailsAccordion>
      <BookingDetailsAccordion
        title={globalContext.translations.supplementsEspaceClient}
        amount={bookingAddedSupplements[booking.id].totalPrice}
        currency={booking.currency}
        type={AccordionType.Supplement}
        trigger={supplementAdded.success && supplementAdded.bookingId == booking.id }
        afterTrigger={() => loadSupplement({ added: { success: false, bookingId: null }})}
      >
        <BookingAddedSupplementList bookingId={booking.id} />
      </BookingDetailsAccordion>
    </>
  )
}

export default connect(mapProps, mapDispatch)(BookingAccordionDetails)